import { RegexEditor } from '../utils/regex_editor'

const _br = /^( {2,}|\\)\n(?!\s*$)/

export const br = new RegexEditor(_br).replace('{2,}', '*').getRegex()
